import {
  Box,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
  Typography,
} from "@mui/material";

import TableRow from "./TableRow";
import TableRowTotal from "./TableRowTotal";

const TableBody = ({
  columns,
  data,
  actionColumn,
  showBorder,
  showHoverRow,
}) => {
  return (
    <MuiTableBody
      sx={{
        ...(showHoverRow && {
          "& tr:hover": {
            bgcolor: (theme) => theme.palette.grey[100],
          },
        }),
      }}>
      <TableRowTotal data={data} columns={columns} showBorder={showBorder} />

      {data?.map((record) => (
        <TableRow
          key={record.id ?? record._id}
          columns={columns}
          record={record}
          actionColumn={actionColumn}
          showBorder={showBorder}
        />
      ))}

      {data?.length === 0 && (
        <MuiTableRow>
          <MuiTableCell colSpan={999}>
            <Box
              sx={{
                height: 100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <Typography fontSize={14} color="gray">
                Không có dữ liệu
              </Typography>
            </Box>
          </MuiTableCell>
        </MuiTableRow>
      )}
    </MuiTableBody>
  );
};

export default TableBody;
